import React from 'react';
import { IGetLoanButtonProps } from './GetLoanButtonProps'
import { Link } from 'react-router-dom'
import { Environment } from '../../../environment/app-settings'
import Cookies from 'universal-cookie/es6'
import { STORAGEKEYS } from '../../../common/keys'

import './GetLoanButton.scss'

const GetLoanButton = (props: IGetLoanButtonProps) => {
   const cookies = new Cookies()
   const affiliateLink = cookies.get(STORAGEKEYS.AFFILIATE_LINK_SEARCH_PARAMS_COOKIE)
   let startProcessUrl = Environment.startOpenaProcessUrl

   // Jeśli udało się odczytać parametry z ciasteczka "AFFILIATE_LINK_SEARCH_PARAMS_COOKIE"
   // przekazujemy je dalej do strony formularza
   if(affiliateLink !== undefined){
      startProcessUrl = `${Environment.startOpenaProcessWithAffiliateDataUrl}${affiliateLink}`
   }

   return (
      <Link 
         to={startProcessUrl} 
         style={{ display: 'block' }}
         className={`${props.additionalClassName ? props.additionalClassName : ''}`}
      >
         <button className={`get-loan-button-main`}>
            Chcę pożyczkę
         </button>
      </Link>
   )
}

export default GetLoanButton
